import axios, {AxiosResponse} from 'axios'
import {Response} from '../../../_metronic/helpers'
import {ISelect} from '../../../coreGlobal/models/default'
import {AdminRoom, AdminRoomsQueryResponse, RoomOption, TAdminRoomRequest} from './_models'
import {AdminProductsResponse, ProductOption, toProductOptions} from '../../../components/ProductSelect'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const ROOM_URL = `${API_URL}/admin/rooms`
const FRANCHISE_URL = `${API_URL}/admin/franchises`
const CATEGORY_URL = `${API_URL}/admin/categories`
const PRODUCT_URL = `${API_URL}/admin/products`

const getRooms = (query: string): Promise<AdminRoomsQueryResponse> => {
  return axios
    .get(`${ROOM_URL}?${query}&include=franchise`)
    .then((d: AxiosResponse<AdminRoomsQueryResponse>) => d.data)
}

const getRoomById = (roomId: string | number): Promise<AdminRoom> => {
  return axios
    .get(`${ROOM_URL}/${roomId}?include=franchise,categories,products,machines,intervals`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const createRoom = (data: TAdminRoomRequest) => {
  return axios
    .post(ROOM_URL, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updateRoom = (roomId: string | number, data: TAdminRoomRequest) => {
  return axios
    .put(`${ROOM_URL}/${roomId}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getFranchises = (): Promise<ISelect[]> => {
  return axios
    .get(`${FRANCHISE_URL}/all`)
    .then((response: AxiosResponse<Response<{id: number; name: string}[]>>) =>
      (response.data.data ?? []).map((franchise) => ({value: String(franchise.id), label: franchise.name}))
    )
}

const getFranchiseMachines = (franchiseId: number): Promise<RoomOption[]> => {
  return axios
    .get(`${FRANCHISE_URL}/${franchiseId}/machines`)
    .then((response: AxiosResponse<Response<RoomOption[]>>) => response.data.data ?? [])
}

const getCategories = (): Promise<RoomOption[]> => {
  return axios
    .get(`${CATEGORY_URL}/all`)
    .then((response: AxiosResponse<Response<RoomOption[]>>) => response.data.data ?? [])
}

// Usa o index do admin porque products/all depende da franquia selecionada na sessão
const getProducts = (categories: string): Promise<ProductOption[]> => {
  return axios
    .get(`${PRODUCT_URL}?category=${categories}&sort=name&order=asc&per_page=1000`)
    .then((response: AxiosResponse<AdminProductsResponse>) => toProductOptions(response.data))
}

export {
  getRooms,
  getRoomById,
  createRoom,
  updateRoom,
  getFranchises,
  getFranchiseMachines,
  getCategories,
  getProducts,
}
